export default "__VITE_ASSET__Bwu0WFX5__"